/**
 * Utility for parsing removed leg notes embedded in parlay reasoning text.
 *
 * Backend appends removed leg info to reasoning with a consistent marker so it
 * persists to the DB. Frontend parses it back out for separate yellow note display.
 */

const REMOVED_LEGS_MARKER = '\n\nRemoved legs: ';

/**
 * Split reasoning into main text and an optional removed-legs note.
 * Returns { mainReasoning, removedLegsNote } where removedLegsNote is null
 * if no embedded note was found.
 */
export function parseReasoningWithRemovedLegs(reasoning: string | null | undefined): {
  mainReasoning: string | null;
  removedLegsNote: string | null;
} {
  if (!reasoning) return { mainReasoning: reasoning ?? null, removedLegsNote: null };
  const idx = reasoning.indexOf(REMOVED_LEGS_MARKER);
  if (idx < 0) return { mainReasoning: reasoning, removedLegsNote: null };
  return {
    mainReasoning: reasoning.slice(0, idx),
    removedLegsNote: reasoning.slice(idx + REMOVED_LEGS_MARKER.length),
  };
}

/**
 * Build the removed-legs suffix to append to reasoning text.
 * Used by the backend after edge filtering.
 */
export function buildRemovedLegsNote(
  removedLegs: Array<{ player: string; prop: string; reason: string }>,
): string {
  if (removedLegs.length === 0) return '';
  const note = removedLegs.map((l) => `${l.player} ${l.prop} — ${l.reason}`).join('; ');
  return `${REMOVED_LEGS_MARKER.trimStart()}${note}`;
}
